import { useState } from 'react';

import { SubscriptionTopic } from '../../../../../../../viewer/messaging/pubsub';
import { ActionName, DesignTool } from '../../../../../../../viewer/tools/design-tool';
import { useSubscribe } from '../../../../../../hooks/use-subscribe';

export function useActionInProgress(tool: DesignTool, actionName?: ActionName) {
  const [actionInProgress, setActionInProgress] = useState(tool.actionInProgress);
  const isActionInProgress = actionName ? actionInProgress?.actionName === actionName : true;
  const [isReadyToApply, setIsReadyToApply] = useState<boolean>(
    tool.actionInProgress?.readyToApply() ?? false,
  );
  const [originPointId, setOriginPointId] = useState(tool.actionInProgress?.originPointId);

  useSubscribe(SubscriptionTopic.DesignToolActiveActionChanged, () => {
    setActionInProgress(tool.actionInProgress);
    setIsReadyToApply(tool.actionInProgress?.readyToApply() ?? false);
    setOriginPointId(tool.actionInProgress?.originPointId);
  });

  return { actionInProgress, isActionInProgress, isReadyToApply, originPointId };
}
